"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('text-underline', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap
  }, _react.default.createElement("g", {
    transform: "translate(8.000000, 6.096979)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M0,37.9030211 L32,37.9030211",
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M29,-1.0658141e-13 C29,6.66666667 29,9.2363544 29,15.9030211 C29,23.0827228 23.1797017,28.9030211 16,28.9030211 C8.82029825,28.9030211 3,23.0827228 3,15.9030211 C3,9.2363544 3,6.66666667 3,-1.0658141e-13"
  }))));
});

exports.default = _default;